export const MUTUAL_APP_LINK = 'https://mutual.app/'
export const LOGIN_LINK = `/login/?redirect_uri=/premium`
export const ACCOUNT_SUBSCRIPTION_MANAGEMENT_LINK = `https://${window.location.host}/account`
export const STRIPE_CHECKOUT_PATH = "/api/purchases" 

export const PIONEER_RELATIVE_PATH = `/premium/`
